<template>
  <div
    class="search-dropdown-content invisible-scroll laptop-position-relative"
    :class="{ 'no-data-found-box': !isSearching && searchQuery != '' && searchSuggestion.length == 0 }"
  >
    <template v-if="isSearching && searchQuery != ''">
      <div class="px-4 py-2">
        <b-skeleton
          v-for="i in 8"
          :key="i"
          class="my-3"
          height="20px"
        ></b-skeleton>
      </div>
    </template>
    <template v-else-if="searchQuery != '' && searchSuggestion.length > 0">
      <div
        class="pointer"
        v-for="(value, index) in searchSuggestion"
        :key="index + 'search'"
        @click="handleSearchClick(value)"
      >
        <article class="d-flex gap-3 align-items-center px-4 py-3">
          <img
            class="ml-2"
            src="../../assets/imgs/newhomepage/searchHead.svg"
            alt=""
          />
          <span class="font-inter fw-500 fs-16">
            {{
              selectedTab == "assessment" || selectedTab == "assessments"
                ? value.name
                : value.title
            }}</span
          >
        </article>
      </div>
    </template>
    <template
      v-else-if="
        !isSearching && searchQuery != '' && searchSuggestion.length == 0
      "
    >
      <div
        class="d-flex h-100 align-items-center justify-content-center font-inter fw-500 fs-16 color-7a7a7a"
      >
        <img src="../../assets/imgs/nodata.svg" alt="" />
      </div>
    </template>
    <template v-else>
      <!-- Recent Search -->
      <div
        class="search-section mobmb-10"
        :class="{ 'is-section-expanded': isRecentExpanded }"
        v-if="recentSearches && recentSearches.length > 0"
      >
        <div class="section-header">
          <h3 class="section-title">Recent Search</h3>
          <button
            v-if="recentSearches && recentSearches.length > 0"
            class="clear-btn"
            @click="clearRecentSearches"
          >
            Clear
          </button>
        </div>
        <div class="mob-hor-scroll invisiblexscroll">
          <div
            class="tags-wrapper"
            :class="{
              'is-expanded': isRecentExpanded,
              'is-measuring': isMeasuringRecent,
              loading: isTagsLoading,
            }"
          >
            <div class="search-tags invisiblexscroll" ref="recentTagsContainer">
              <template v-if="isTagsLoading">
               <div class="tags-row" v-if="!isLaptop">
									<b-skeleton
										v-for="i in 5"
										:key="i + 'recent-shimmer-1'"
										width="100px"
										height="30px"
										style="border-radius: 20px"
									></b-skeleton>
								</div>
								<div class="tags-row" v-if="!isLaptop">
									<b-skeleton
										v-for="i in 5"
										:key="i + 'recent-shimmer-2'"
										width="100px"
										height="30px"
										style="border-radius: 20px"
									></b-skeleton>
								</div>
                <template v-if="isLaptop">
									<b-skeleton
										v-for="i in 5"
										:key="i + 'recent-shimmer-desktop'"
										width="130px"
										height="30px"
										style="border-radius: 20px"
									></b-skeleton>
								</template>
              </template>
              <template v-else>
                <template v-if="isLaptop">
                <span
                  class="search-tag"
                  v-for="(tag, index) in visibleRecentSearches"
                  :key="`recent-${index}`"
                  ref="recentTag"
                  @click="handleSearchClick(tag)"
                >
                  <img
                    src="../../assets/imgs/newhomepage/black-search.svg"
                    alt="Recent Search Icon"
                    class="tag-icon"
                  />
                  <span style="max-width: 100%" class="text-truncate">
                    {{
                      typeof tag === "string"
                        ? tag
                        : tag.searchQuery || tag.tag || tag.query || tag.name
                    }}
                  </span>
                </span>
              <div
                class="toggle-expand"
                ref="recentToggle"
                v-if="showRecentToggle && !isTagsLoading && !isMeasuringRecent"
                @click.stop="isRecentExpanded = !isRecentExpanded"
              >
                {{ isRecentExpanded ? "Show Less" : "Show More" }}
              </div>
               </template>
                <template v-else>
                  <div class="tags-row">
                    <div
                      class="search-tag"
                      v-for="(tag, index) in recentSearchRows.row1"
                      :key="`recent-r1-${index}`"
                      ref="recentTag"
                      @click="handleSearchClick(tag)"
                    >
                      <img
                        src="../../assets/imgs/newhomepage/black-search.svg"
                        alt="Recent Search Icon"
                        class="tag-icon"
                      />
                      <span style="max-width: 100%" class="text-truncate">
                        {{
                          typeof tag === "string"
                            ? tag
                            : tag.searchQuery || tag.tag || tag.query || tag.name
                        }}
                      </span>
                    </div>
                  </div>
                  <div class="tags-row" v-if="recentSearchRows.row2.length > 0">
                    <div
                      class="search-tag"
                      v-for="(tag, index) in recentSearchRows.row2"
                      :key="`recent-r2-${index}`"
                      ref="recentTag"
                      @click="handleSearchClick(tag)"
                    >
                      <img
                        src="../../assets/imgs/newhomepage/black-search.svg"
                        alt="Recent Search Icon"
                        class="tag-icon"
                      />
                      <span style="max-width: 100%" class="text-truncate">
                        {{
                          typeof tag === "string"
                            ? tag
                            : tag.searchQuery || tag.tag || tag.query || tag.name
                        }}
                      </span>
                    </div>
                  </div>
                </template>
                </template>
                
            </div>
          </div>
        </div>
      </div>

      <!-- Explore -->
      <div class="search-section">
        <div class="d-flex gap-2 align-items-center">
          <h3 class="section-title">Explore</h3>
          <div id="hideinlaptop" class="hor-line"></div>
        </div>
        <div class="explore-grid">
          <div class="scroll">
            <div
              class="explore-item"
              v-for="item in exploreItems"
              :key="item.name"
              @click="
                hasAccess()
                  ? handleExploreClick(item)
                  : handleLoggedOutExploreClick(item)
              "
            >
              <div class="explore-icon">
                <img :src="item.icon" :alt="item.name" />
              </div>
              <span class="explore-label">{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Trending -->
      <div
        v-if="trendingTags && trendingTags.length"
        class="search-section"
        :class="{ 'is-section-expanded': isTrendingExpanded }"
      >
        <div class="d-flex gap-2 align-items-center">
          <h3 class="section-title">Trending on Hire3x</h3>
          <div id="hideinlaptop" class="hor-line"></div>
        </div>
        <div class="mob-hor-scroll invisiblexscroll">
          <div
            class="tags-wrapper"
            :class="{
              'is-expanded': isTrendingExpanded,
              'is-measuring': isMeasuringTrending,
              loading: isTagsLoading,
            }"
          >
            <div
              class="trending-tags invisiblexscroll"
              ref="trendingTagsContainer"
            >
              <template v-if="isTagsLoading">
                <div class="tags-row" v-if="!isLaptop">
                  <b-skeleton
                    v-for="i in 5"
                    :key="i + 'trend-shimmer-1'"
                    width="100px"
                    height="30px"
                    style="border-radius: 20px"
                  ></b-skeleton>
                </div>
                <div class="tags-row" v-if="!isLaptop">
                  <b-skeleton
                    v-for="i in 5"
                    :key="i + 'trend-shimmer-2'"
                    width="100px"
                    height="30px"
                    style="border-radius: 20px"
                  ></b-skeleton>
                </div>
                <template v-if="isLaptop">
                  <b-skeleton
                    v-for="i in 5"
                    :key="i + 'shimmer'"
                    width="130px"
                    height="30px"
                    style="border-radius: 20px"
                  ></b-skeleton>
                </template>
              </template>
              <template v-else>
                <template v-if="isLaptop">
                  <span
                    class="trending-tag"
                    v-for="(tag, index) in visibleTrendingTags"
                    :key="`trending-dt-${index}`"
                    ref="trendingTag"
                    @click="
                      hasAccess()
                        ? handleTrendingClick(tag)
                        : handleLoggeOutTrendingClick(tag)
                    "
                  >
                    {{
                      typeof tag === "string"
                        ? tag
                        : selectedTab == "assessment" ||
                          selectedTab == "assessments"
                        ? tag.testName || tag.name || tag.title || ""
                        : tag.title ||
                          tag.courseName ||
                          tag.name ||
                          tag.tagName ||
                          tag.searchTerm ||
                          ""
                    }}
                  </span>
                </template>
                <template v-else>
                  <div class="tags-row">
                    <span
                      class="trending-tag"
                      v-for="(tag, index) in trendingSearchRows.row1"
                      :key="`trending-r1-${index}`"
                      ref="trendingTag"
                      @click="
                        hasAccess()
                          ? handleTrendingClick(tag)
                          : handleLoggeOutTrendingClick(tag)
                      "
                    >
                      {{
                        typeof tag === "string"
                          ? tag
                          : selectedTab == "assessment" ||
                            selectedTab == "assessments"
                          ? tag.testName || tag.name || tag.title || ""
                          : tag.title ||
                            tag.courseName ||
                            tag.name ||
                            tag.tagName ||
                            tag.searchTerm ||
                            ""
                      }}
                    </span>
                  </div>
                  <div
                    class="tags-row"
                    v-if="trendingSearchRows.row2.length > 0"
                  >
                    <span
                      class="trending-tag"
                      v-for="(tag, index) in trendingSearchRows.row2"
                      :key="`trending-r2-${index}`"
                      ref="trendingTag"
                      @click="
                        hasAccess()
                          ? handleTrendingClick(tag)
                          : handleLoggeOutTrendingClick(tag)
                      "
                    >
                      {{
                        typeof tag === "string"
                          ? tag
                          : selectedTab == "assessment" ||
                            selectedTab == "assessments"
                          ? tag.testName || tag.name || tag.title || ""
                          : tag.title ||
                            tag.courseName ||
                            tag.name ||
                            tag.tagName ||
                            tag.searchTerm ||
                            ""
                      }}
                    </span>
                  </div>
                </template>
              </template>
              <div
                class="toggle-expand"
                ref="trendingToggle"
                v-if="
                  showTrendingToggle && !isTagsLoading && !isMeasuringTrending
                "
                @click.stop="isTrendingExpanded = !isTrendingExpanded"
              >
                {{ isTrendingExpanded ? "Show Less" : "Show More" }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Build Career Section -->
      <div class="build-section w-unset">
        <div class="build-heading">
          Build a career <br />
          you'll love with Hire3x
        </div>
        <div class="double-image">
          <img
            class="one"
            src="../../assets/imgs/newhomepage/bluebannerweb.webp"
            alt="Build a career background"
          />
          <img
            class="two"
            src="@/assets/imgs/newhomepage/person-hire3xweb.webp"
            alt="Person pointing at Hire3x text"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { getAccess } from '@/utils/helpers';
import globalSearchMixin from "../../utils/mixins/globalSearchMixin";

export default {
  name: "SearchDropdown",
  mixins: [globalSearchMixin],
  data() {
    return {
      isTagsLoading: true,
      exploreItems: [
        {
          name: "Resume",
          icon: require("../../assets/imgs/newhomepage/resumeweb.webp"),
        },
        {
          name: "Interviews",
          icon: require("../../assets/imgs/newhomepage/scaredweb.webp"),
        },
        {
          name: "Jobs",
          icon: require("../../assets/imgs/newhomepage/lookingweb.webp"),
        },
        {
          name: "Courses",
          icon: require("../../assets/imgs/newhomepage/booksweb.webp"),
        },
        {
          name: "Roadmap",
          icon: require("../../assets/imgs/newhomepage/Preview.webp"),
        },
        {
          name: "Fix Resume",
          icon: require("../../assets/imgs/newhomepage/shortlistweb.webp"),
        },
        {
          name: "Assessment",
          icon: require("../../assets/imgs/newhomepage/cupweb.webp"),
        },
        // {
        //   name: "Mentor",
        //   icon: require("../../assets/imgs/newhomepage/h-mentor.svg"),
        // },
      ],
      isRecentExpanded: false,
      isTrendingExpanded: false,
      isMeasuringRecent: false,
      isMeasuringTrending: false,
      recentLimit: 2,
      trendingLimit: 2,
      isLaptop: true,
    };
  },
  props: {
    selectedTab: String,
    pSearchSuggestion: Array,
    pSearchQuery: String,
    pIsSearching: Boolean,
    isVisible: Boolean,
  },
  computed: {
    searchQuery() {
      return this.pSearchQuery;
    },
    searchSuggestion() {
      return this.pSearchSuggestion;
    },
    isSearching() {
      return this.pIsSearching;
    },

    visibleRecentSearches() {
      if (this.isRecentExpanded || this.isMeasuringRecent) {
        return this.recentSearches;
      }
      return this.recentSearches.slice(0, this.recentLimit);
    },
    showRecentToggle() {
      if (!this.isLaptop) return false;
      return (
        this.recentSearches.length > this.recentLimit || this.isRecentExpanded
      );
    },
    visibleTrendingTags() {
      if (this.isTrendingExpanded || this.isMeasuringTrending) {
        return this.trendingTags;
      }
      return this.trendingTags.slice(0, this.trendingLimit);
    },
    showTrendingToggle() {
      if (!this.isLaptop) return false;
      return (
        this.trendingTags.length > this.trendingLimit || this.isTrendingExpanded
      );
    },
    recentSearchRows() {
      const len = this.recentSearches.length;
      if (this.isLaptop || len === 0) {
        return { row1: [], row2: [] };
      }
      if (len <= 3) {
        return { row1: this.recentSearches, row2: [] };
      }
      const half = Math.ceil(len / 2);
      return {
        row1: this.recentSearches.slice(0, half),
        row2: this.recentSearches.slice(half),
      };
    },
    trendingSearchRows() {
      const len = this.trendingTags.length;
      if (this.isLaptop || len === 0) {
        return { row1: [], row2: [] };
      }
      if (len <= 3) {
        return { row1: this.trendingTags, row2: [] };
      }
      const half = Math.ceil(len / 2);
      return {
        row1: this.trendingTags.slice(0, half),
        row2: this.trendingTags.slice(half),
      };
    },
  },
  watch: {
    selectedTab(value, oldValue) {
      // Prevent reloading if data is already loading or if it's the same tab
      if (
        value &&
        this._initialLoadDone &&
        !this.isTagsLoading &&
        value !== oldValue
      ) {
        this.loadSearchData();
        this.isRecentExpanded = false;
        this.isTrendingExpanded = false;
      }
    },
    isTagsLoading(value) {
      if (!value) {
        this.$nextTick(() => {
          this.updateLimits();
        });
      }
    },
    recentSearches() {
      this.updateLimits();
    },
    trendingTags() {
      this.updateLimits();
    },
    isVisible(newVal) {
      if (newVal) {
        setTimeout(async () => {
          await this.getInitialData();
          this.updateLimits();
        }, 150);
      }
    },
  },
  created() {
   this.getInitialData();
  },
  mounted() {
    this.checkScreenSize();
    // Delay measurement to ensure smooth opening transition
    setTimeout(() => {
      this.updateLimits();
      window.addEventListener("resize", this.handleResize);
      this.resizeObserver = new ResizeObserver(() => {
        requestAnimationFrame(() => {
          this.handleResize();
        });
      });
      if (this.$refs.recentTagsContainer)
        this.resizeObserver.observe(this.$refs.recentTagsContainer);
      if (this.$refs.trendingTagsContainer)
        this.resizeObserver.observe(this.$refs.trendingTagsContainer);
    }, 150);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.resizeObserver) this.resizeObserver.disconnect();
  },
  methods: {
    getInitialData(){
       this.loadSearchData().then(() => {
      this._initialLoadDone = true;
    });
    },
    checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},
    async loadSearchData() {
      this.isTagsLoading = true;
      try {
        await Promise.all([
          this.getRecentSearches(this.selectedTab, 50),
          this.getTrendingTagsData(this.selectedTab),
        ]);
      } finally {
        this.isTagsLoading = false;
      }
    },
    getOneRowLimit(tagRefName, totalItems) {
      const tagNodes = this.$refs[tagRefName];
      if (!tagNodes) return 0;

      const tags = Array.isArray(tagNodes) ? tagNodes : [tagNodes];
      if (!tags.length) return 0;

      const rowTops = [];
      let oneRowIndex = tags.length;
      
      const addRowTop = (top) => {
        if (top === undefined) return;
        const exists = rowTops.some(rowTop => Math.abs(rowTop - top) < 15);
        if (!exists) {
          rowTops.push(top);
        }
      };

      for (let i = 0; i < tags.length; i++) {
        const top = tags[i].offsetTop;
        addRowTop(top);
        if (rowTops.length > 1) {
          oneRowIndex = i;
          break;
        }
      }

      // Reserve one slot for Show More button if there are more items beyond this limit
      if (totalItems > oneRowIndex && oneRowIndex > 0) {
        oneRowIndex = Math.max(1, oneRowIndex - 1);
      }

      return oneRowIndex;
    },
    handleResize() {
      this.checkScreenSize();
      this.updateLimits();
    },
    updateLimits() {
      if (!this.isRecentExpanded) {
        this.recentLimit = this.recentSearches.length;
        this.isMeasuringRecent = true;
      }
      if (!this.isTrendingExpanded) {
        this.trendingLimit = this.trendingTags.length;
        this.isMeasuringTrending = true;
      }

      this.$nextTick(() => {
        this.$nextTick(() => {
          if (!this.isRecentExpanded) {
            const recentOneRowLimit = this.getOneRowLimit(
              "recentTag",
              this.recentSearches.length,
            );
            this.recentLimit =
              recentOneRowLimit > 0
                ? recentOneRowLimit
                : Math.min(this.recentSearches.length, 6);
            if (this.recentSearches.length > this.recentLimit) {
              this.$nextTick(() => {
                this.ensureMaxOneRowWithToggle(
                  "recentTag",
                  "recentToggle",
                  "recentLimit",
                  this.recentSearches.length,
                );
              });
            }
          }

          if (!this.isTrendingExpanded) {
            const trendingOneRowLimit = this.getOneRowLimit(
              "trendingTag",
              this.trendingTags.length,
            );
            this.trendingLimit =
              trendingOneRowLimit > 0
                ? trendingOneRowLimit
                : Math.min(this.trendingTags.length, 4);
            if (this.trendingTags.length > this.trendingLimit) {
              this.$nextTick(() => {
                this.ensureMaxOneRowWithToggle(
                  "trendingTag",
                  "trendingToggle",
                  "trendingLimit",
                  this.trendingTags.length,
                );
              });
            }
          }

          this.isMeasuringRecent = false;
          this.isMeasuringTrending = false;
        });
      });
    },
    ensureMaxOneRowWithToggle(
      tagRefName,
      toggleRefName,
      limitKey,
      totalItems,
    ) {
      const toggleNode = this.$refs[toggleRefName];
      const tagNodes = this.$refs[tagRefName];
      if (!toggleNode || !tagNodes) return;

      const tags = Array.isArray(tagNodes) ? tagNodes : [tagNodes];
      if (!tags.length) return;

      const rowTops = [];
      const addRowTop = (top) => {
        if (top === undefined) return;
        const exists = rowTops.some(rowTop => Math.abs(rowTop - top) < 15);
        if (!exists) {
          rowTops.push(top);
        }
      };

      tags.forEach((tag) => {
        if (tag && tag.offsetTop !== undefined) {
          addRowTop(tag.offsetTop);
        }
      });

      if (toggleNode.offsetTop !== undefined) {
        addRowTop(toggleNode.offsetTop);
      }

      if (rowTops.length > 1 && this[limitKey] > 1) {
        this[limitKey] = Math.max(1, this[limitKey] - 1);
        if (totalItems > this[limitKey]) {
          this.$nextTick(() => {
            this.ensureMaxOneRowWithToggle(
              tagRefName,
              toggleRefName,
              limitKey,
              totalItems,
            );
          });
        }
      }
    },
    handleSearchClick(tag) {
      const query =
        typeof tag === "string"
          ? tag
          : tag.searchQuery ||
            tag.tag ||
            tag.query ||
            tag.name ||
            tag.title ||
            tag.courseName;

      if (query) {
        const type = this.selectedTab;
        this.$emit("close-modal");
        this.handleEnterSearch(query, type);
      }
    },
    handleExploreClick(item) {
      this.$emit("close-modal");
      this.$emit("explore-click", item);
    },
    handleLoggedOutExploreClick(item) {
      this.$emit("close-modal");
      this.$emit("explore-click-logged-out", item);
    },
    goToCourseDetail(tag) {
      this.$emit("close-modal");
      const courseName = tag.title || tag.courseName || tag.name;
      const courseId =
        tag.courseID || tag.courseId || tag.referenceID || tag.id;
      if (!courseId) {
        this.handleEnterSearch(courseName, "courses");
        return;
      }

      this.trackSearchInteraction(courseName, "courses");

      const encodedCourseName = encodeURIComponent(courseName || "");
      const link = `${this.config.trainingBase}/coursedetail/${courseId}?courseName=${encodedCourseName}`;
      window.open(link, "_self");
    },
    goToJobDetail(tag) {
      this.$emit("close-modal");
      const jobId = tag.jobID || tag.referenceID || tag.id;
      const jobTitle = tag.title || tag.name || tag.jobTitle;

      this.trackSearchInteraction(jobTitle, "job");

      if (jobId) {
        if (!this.hasAccess() || !getAccess("candidate")) {
          const pagePath = this.$route.path.substring(1);
          window.open(
            `${this.config.candidateBase}/jobinfo?jobID=${jobId}&from=candidate&fromProject=website&fromPage=${pagePath}`,
            "_self",
          );
        } else {
          this.handleEnterSearch(jobTitle, "job", jobId);
        }
      } else {
        this.handleEnterSearch(jobTitle, "job");
      }
    },
    goToAssessmentDetail(tag) {
      this.$emit("close-modal");
      const testId = tag.testID || tag.testId || tag.referenceID || tag.id;
      const testName = tag.testName || tag.title || tag.name;

      this.trackSearchInteraction(testName, "assessment");

      if (testId && !this.hasAccess()) {
        window.open(
          `${this.config.candidateBase}/testdetails?testID=${testId}&from=candidate`,
          "_self",
        );
      } else {
        this.handleEnterSearch(testName, "assessment");
      }
    },
    handleLoggeOutTrendingClick(tag) {
      const type = this.selectedTab;
      if (type === "courses" || type === "course" || type === 3) {
        this.goToCourseDetail(tag);
      } else if (type === "job" || type === "jobs" || type === 1) {
        this.goToJobDetail(tag);
      } else if (
        type === "assessment" ||
        type === "assessments" ||
        type === 2
      ) {
        this.goToAssessmentDetail(tag);
      } else {
        const queryTerm = tag.testName || tag.title || tag.name;
        this.handleEnterSearch(queryTerm, type);
      }
    },
    handleTrendingClick(tag) {
      const type = this.selectedTab;

      // For trending tags, we want to go to the detail page directly if possible
      if (type === "courses" || type === "course" || type === 3) {
        this.goToCourseDetail(tag);
      } else if (type === "job" || type === "jobs" || type === 1) {
        this.goToJobDetail(tag);
      } else if (
        type === "assessment" ||
        type === "assessments" ||
        type === 2
      ) {
        const queryTerm = tag.testName || tag.name || tag.title || "";
        if (!queryTerm) return;
        this.$emit("close-modal");
        this.trackSearchInteraction(queryTerm, "assessment");
        console.log(tag)
        if(tag.referenceID && !getAccess("candidate")){
           window.open(
          `${this.config.candidateBase}/testdetails?testID=${tag.referenceID}&from=candidate`,
          "_self",
        );
        }else{
        window.open(
          `${this.config.candidateBase}/assessment/progress?searchQuery=${encodeURIComponent(queryTerm)}&from=candidate&source=trendingTag`,
          "_self",
        );
        }
      } else {
        const queryTerm =
          type === "assessment" || type === "assessments" || type === 2
            ? tag.testName || tag.name || tag.title || ""
            : tag.title || tag.courseName || tag.name || tag.tagName || "";

        this.$emit("close-modal");
        this.handleEnterSearch(queryTerm, type);
      }
    },
  },
};
</script>

<style lang="scss">
.search-dropdown-content {
  background: white;
  border-radius: 20px;
  min-height: auto;
  width: 100%;
  padding: 20px 0;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  max-height: 75vh;
  overflow-y: auto;
  margin-top: 10px;
  will-change: transform;
  box-shadow: 8px 2px 19px 0px #0000001a, 33px 10px 35px 0px #00000017,
    75px 22px 47px 0px #0000000d, 133px 38px 56px 0px #00000003,
    208px 60px 61px 0px #00000000;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Search Dropdown Styles */
.search-section {
  margin-bottom: 13px;
  padding-inline: 20px;
}

.search-section:last-child {
  margin-bottom: 0;
}

.section-header {
  display: flex;
  gap: 30px;
  align-items: center;
  margin-bottom: 16px;
}



.clear-btn {
  background: none;
  border: none;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
}

.clear-btn:hover {
  color: #4a7eff;
}

.tags-wrapper {
  position: relative;
  margin-top: 16px;
  overflow: hidden;
  transition: max-height 0.3s ease;
  width: 100%;
  min-height: 45px; /* Minimum height to prevent collapse */

  &:not(.is-expanded):not(.is-measuring) {
    max-height: 55px;
  }

  &.loading:not(.is-expanded) {
    max-height: 55px;
    min-height: 55px; /* Keep height stable during loading */
  }

  &.is-expanded {
    max-height: none;
  }
}

.toggle-expand {
  display: inline-flex;
  align-items: center;
  color: #4A7EFF;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;
  transition: all 0.2s ease;
  white-space: nowrap;
  height: 32px;
  padding: 4px 5px;
  margin: 0 0 0 4px;
  flex-shrink: 0;
}

.toggle-expand:hover {
  opacity: 0.8;
  color: #3B6EEF;
}

.search-tags,
.trending-tags {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: wrap !important;
  gap: 12px;
  align-items: center;
  padding-bottom: 12px;
  width: 100%;
}

.trending-tag {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  background: #f0f7ff;
  border: 1px solid rgba(74, 126, 255, 0.3);
  color: #4A7EFF;
  border-radius: 20px;
  padding: 6px 16px;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s ease;
  max-width: 85%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 0 1 auto;
}

.trending-tag:hover {
  background: #ffffff;
  border: 1px solid #4a7eff;
  color: #4a7eff;
}

.search-tag {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  background: #f9f9f9;
  color: #646464;
  border-radius: 20px;
  padding: 4px 16px;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s ease;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 0 1 auto;
}

.search-tag:hover {
  background: #eeeeee;
}

.tag-icon {
  width: 14px;
  height: 14px;
  opacity: 0.6;
}

.explore-grid {
  overflow-x: auto;
  padding-top: 5px;
  padding-bottom: 8px;
}

.explore-grid .scroll {
  display: flex;
  gap: 24px;
}

.explore-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.explore-icon {
  width: 82px;
  height: 82px;
  border: 1.06px solid #EDEDED;
  background: #F9F9F9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease;
}

@media (max-width: 1028px) {
  .explore-icon {
    width: 72px;
    height: 72px;
  }

}

.explore-item:hover .explore-icon {
  background: #e3f2fd;
}

.explore-icon img {
  height: 42px;
  width:42px;
}

.explore-label {
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  font-family: "Inter", sans-serif;
  margin-top: 6px;
}

.mob-hor-scroll {
  width: 100%;
}
.invisiblexscroll {
  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }
}
.invisible-scroll::-webkit-scrollbar {
  display: none;
}
.invisible-scroll {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.tag-text {
  flex: 1; /* take remaining space */
  min-width: 0; /* VERY IMPORTANT for flex */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: 1028px) {
  .mobmb-10 {
    margin-bottom: 10px !important;
  }
  .tags-wrapper {
    margin-top: 5px;
    overflow-x: auto;
    overflow-y: hidden;
  }
  .search-tags,
  .trending-tags {
    padding-bottom: 0;
  }
  .search-dropdown-content {
    .mob-hor-scroll {
      width: 100%;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }
    .mob-hor-scroll::-webkit-scrollbar {
      display: none;
    }
    .mob-hor-scroll .tags-wrapper {
      width: max-content;
      overflow: visible;
      max-height: none !important;
    }
    .mob-hor-scroll .search-tags,
    .mob-hor-scroll .trending-tags {
      display: flex !important;
      flex-direction: column !important;
      gap: 8px;
      width: max-content;
      max-height: none;
      overflow: visible;
      padding-bottom: 8px;
      align-items: flex-start;
    }
    .tags-row {
      display: flex !important;
      flex-direction: row !important;
      gap: 8px;
      width: max-content;
    }
    &.no-data-found-box {
      height: calc(100dvh - 168px) !important;
    }
  }
}
@media (min-width: 1029px) {
  .search-dropdown-content .b-skeleton {
    overflow: unset;
  }
  .b-skeleton-animate-wave::after {
    z-index: 9999;
  }
  @keyframes b-skeleton-animate-wave {
    0% {
      transform: translateX(0);
    }

    100% {
      transform: translateX(50%);
    }
  }
  .search-dropdown-content {
    contain: paint;
    isolation: isolate;
  }
  .b-skeleton,
  .b-skeleton-animate-wave,
  .b-skeleton-animate-wave::after {
    will-change: auto !important;
    backface-visibility: hidden;
    transform: translateZ(0);
  }
  .laptop-position-relative {
    position: relative;
  }
  .search-dropdown-content.no-data-found-box {
    height: 50vh !important;
  }
  .clear-btn {
    color: #AFAFAF !important;
    font-family: 'Inter', sans-serif !important;
    font-size: 18px !important;
    font-weight: 500 !important;
  }
  .clear-btn:hover {
    color: #AFAFAF !important;
  }
}
</style>
